import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { PaneComponent } from '@rocksoft/cdk';

@Component({
  selector: 'ml-voice-roaming-ui',
  templateUrl: 'voice-roaming.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaneComponent, ReactiveFormsModule, AsyncPipe],
})
export class ManagedSettingsVoiceRoamingComponent {
  private readonly fb = inject(UntypedFormBuilder);

  readonly voiceRoaming = output<boolean>();

  public readonly voiceRoamingForm = this.fb.group({
    voiceRoamingEnabled: [false],
  });

  get voiceRoamingEnabled() {
    return this.voiceRoamingForm.get('voiceRoamingEnabled') as UntypedFormControl;
  }

  onSubmit() {
    this.voiceRoaming.emit(this.voiceRoamingEnabled.value);
  }
}
